<template>
  <footer class="footer-nav">
    <div class="footer-top">
      <div class="footer-logo-section">
        <div class="footer-logo-brand-row">
          <img src="@/assets/images/whiteLogo.png" alt="logo" class="footer-logo" />
          <div class="footer-brand">
            <div class="footer-brand-title">{{ $t('footer.name2') }}</div>
          </div>
        </div>
        <div class="footer-contact-card">
          <div class="contact-item">
            <div class="contact-label">{{ $t('footer.contact.wechat') }}</div>
            <div class="contact-value">clarewang23</div>
          </div>
          <div class="contact-item contact-item-email">
            <div class="contact-label">{{ $t('footer.contact.email') }}</div>
            <div class="contact-value">clarewang@btinternet.com</div>
          </div>
          <div class="contact-item">
            <div class="contact-label">{{ $t('footer.contact.phone') }}</div>
            <div class="contact-value">+44 (0) 7887 505508</div>
          </div>
        </div>
      </div>
      <!-- <div class="footer-touch-section">
        <div class="footer-touch-title">{{ $t('footer.title') }}</div>
        <div class="footer-touch-desc"></div>
        <div class="footer-socials">
          <span class="footer-social-icon" @click="goToWechat"><i class="el-icon-chat-dot-round"></i></span>
          <span class="footer-social-icon" @click="shareToWechat"><i class="el-icon-share"></i></span>
        </div>
      </div> -->
    </div>
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <div class="copyright">
          <p>&copy; {{ currentYear }} Hope Guardianship. All rights reserved.</p>
        </div>
        <div class="footer-bottom-links">
          <router-link to="/" class="footer-bottom-link" active-class="active-link" exact>{{ $t('nav.home')
          }}</router-link>
          <router-link to="/services" class="footer-bottom-link" active-class="active-link">{{ $t('nav.services')
          }}</router-link>
          <router-link to="/about" class="footer-bottom-link" active-class="active-link">{{ $t('nav.story')
          }}</router-link>
          <router-link to="/testimonials" class="footer-bottom-link" active-class="active-link">{{
            $t('nav.testimonials') }}</router-link>
          <router-link to="/parents" class="footer-bottom-link" active-class="active-link">{{ $t('nav.parents')
          }}</router-link>
          <router-link to="/blog" class="footer-bottom-link" active-class="active-link">{{ $t('nav.blog')
          }}</router-link>
          <router-link to="/policies" class="footer-bottom-link" active-class="active-link">{{ $t('nav.policies')
          }}</router-link>
        </div>
      </div>
      <div v-if="showQrModal" class="qr-modal-mask" @click.self="showQrModal = false">
        <div class="qr-modal-content">
          <img src="@/assets/images/close.png" alt="关闭" class="qr-modal-close" @click="showQrModal = false" />
          <img :src="require('@/assets/images/QR (1).png')" alt="WeChat QR" class="qr-modal-img" />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterNav',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  data() {
    return {
      showQrModal: false
    }
  },
  methods: {
    goToWechat() {
      console.log('goToWechat');
      this.showQrModal = true;
    },
    async shareToWechat() {
      console.log('shareToWechat');
      //复制当前页面链接
      const url = window.location.href;

      try {
        // 检查是否支持 Clipboard API
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
          this.$message.success(this.$t('footer.shareSuccess'));
        } else {
          // 降级方案：使用传统的复制方法
          this.fallbackCopyTextToClipboard(url);
        }
      } catch (error) {
        console.error('复制失败:', error);
        // 降级方案：使用传统的复制方法
        this.fallbackCopyTextToClipboard(url);
      }
    },

    fallbackCopyTextToClipboard(text) {
      try {
        // 创建临时文本区域
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);

        if (successful) {
          this.$message.success(this.$t('footer.shareSuccess'));
        } else {
          this.$message.error(this.$t('footer.shareError'));
        }
      } catch (error) {
        console.error('降级复制也失败:', error);
        this.$message.error('复制失败，请手动复制链接');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-nav {
  width: 100%;
  background: #267E75;
  display: block;

  // @media (max-width: 1023px) {
  //   display: none;
  // }

  .footer-top {
    width: 100%;
    height: 144px;
    position: relative;

    @media (max-width: 900px) {
      flex-direction: column;
      height: auto;
      padding: 30px 0 0 0;
    }

    .footer-logo-section {
      position: relative;
      display: flex;
      align-items: flex-end;
      justify-content: space-around;
      position: relative;
      gap: 82px;
      height: 100%;

      .footer-logo-brand-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 18px;
        margin-top: 45px;
        margin-bottom: 32px;
      }

      .footer-logo {
        width: 70px;
        height: 70px;
        margin-bottom: 0;
      }

      .footer-brand {
        .footer-brand-title {
          color: #fff;
          font-size: 36px;
          font-weight: 600;
          line-height: 40px;
          margin-bottom: 0;
        }
      }

      .footer-contact-card {
        background: #FCD980;
        width: 740px;
        height: 95px;
        border-top-left-radius: 40px;
        border-top-right-radius: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0px 0 40px;
        margin-top: 3px;
        box-sizing: border-box;

        @media (max-width: 900px) {
          width: 95vw;
          min-width: 0;
          margin-top: 20px;
          padding: 0 10px;
          height: auto;
        }

        .contact-item {
          flex: 1 1 0;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          min-width: 0;
          text-align: left;

          .contact-label {
            color: #282938;
            font-weight: 500;
            font-size: 18px;
            margin-bottom: 2px;
            white-space: nowrap;
          }

          .contact-value {
            color: #282938;
            font-size: 16px;
            font-weight: 400;
            word-break: break-all;
            opacity: 0.8;
          }
        }

        // 让第二个.contact-item的.contact-value始终一行展示
        .contact-item:nth-child(2) .contact-value {
          white-space: nowrap;
          word-break: normal;
        }

        .contact-item-email {
          margin-left: -95px;
        }
      }
    }

    .footer-touch-section {
      margin-top: 80px;
      margin-right: 120px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      @media (max-width: 900px) {
        margin: 40px 0 0 0;
        align-items: flex-start;
      }

      .footer-touch-title {
        color: #fff;
        font-size: 54px;
        font-weight: 700;
        margin-bottom: 20px;
      }

      .footer-touch-desc {
        color: #D9D9D9;
        font-size: 20px;
        margin-bottom: 30px;
      }

      .footer-socials {
        display: flex;
        gap: 30px;

        .footer-social-icon {
          width: 40px;
          height: 40px;
          background: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #267E75;
          font-size: 22px;
        }
      }
    }
  }

  .footer-bottom {
    width: 100%;
    height: 92px;
    background: #fff;

    .footer-bottom-content {
      width: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0px 80px 0 80px;
      line-height: 92px;

      @media (max-width: 900px) {
        flex-direction: column;
        gap: 15px;
        text-align: center;
        padding: 20px 10px 0 10px;
      }

      .copyright {
        p {
          color: #282938;
          font-size: 16px;
          margin: 0;
          font-weight: 500 !important;
        }
        
        .beian-link {
          color: #282938;
          text-decoration: none;
          transition: color 0.3s;
          
          &:hover {
            color: #267E75;
            text-decoration: underline;
          }
        }
      }

      .footer-bottom-links {
        display: flex;
        gap: 32px;
        flex-wrap: wrap;

        .footer-bottom-link {
          color: #282938;
          text-decoration: none;
          font-size: 16px;
          font-weight: 500;
          transition: color 0.3s;
          opacity: 0.5;

          &.active {
            font-weight: 700;
            opacity: 1;
          }

          &:hover {
            color: #282938;
            opacity: 1;
          }

          &.active-link {
            color: #282938;
            opacity: 1;
          }
        }
      }
    }
  }

  // 弹窗样式
  .qr-modal-mask {
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qr-modal-content {
    background: #fff;
    border-radius: 40px;
    padding: 0;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .qr-modal-img {
    width: 267px;
    height: 361px;
    border-radius: 40px;
    object-fit: cover;
    display: block;
  }

  .qr-modal-close {
    position: absolute;
    top: -40px;
    right: -14px;
    width: 32px;
    height: 32px;
    cursor: pointer;
    z-index: 10;
  }

  // 弹窗样式
  .qr-modal-mask {
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qr-modal-content {
    background: #fff;
    border-radius: 40px;
    padding: 0;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .qr-modal-img {
    width: 267px;
    height: 361px;
    border-radius: 40px;
    object-fit: cover;
    display: block;
  }

  .qr-modal-close {
    position: absolute;
    top: -40px;
    right: -14px;
    width: 32px;
    height: 32px;
    cursor: pointer;
    z-index: 10;
  }
}

@media (max-width: 900px) {
  .footer-nav {
    .footer-top {
      .footer-logo-section {
        margin-left: 10px;

        .footer-brand-title {
          font-size: 28px;
        }

        .footer-contact-card {
          width: 100%;
          min-width: 0;
          padding: 0 4vw;

          .contact-label,
          .contact-value {
            font-size: 14px;
          }
        }
      }

      .footer-touch-section {
        margin-right: 0;

        .footer-touch-title {
          font-size: 32px;
        }

        .footer-touch-desc {
          font-size: 16px;
        }
      }
    }

    // 弹窗样式
    .qr-modal-mask {
      position: fixed;
      z-index: 9999;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .qr-modal-content {
      background: #fff;
      border-radius: 40px;
      padding: 0;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }

    .qr-modal-img {
      width: 267px;
      height: 361px;
      border-radius: 40px;
      object-fit: cover;
      display: block;
    }

    .qr-modal-close {
      position: absolute;
      top: -40px;
      right: -14px;
      width: 32px;
      height: 32px;
      cursor: pointer;
      z-index: 10;
    }
  }


}
</style>